import { z } from "zod";

export const newHireReportingSummaryItemSchema = z.object({
  sent_date: z.string(),
  state: z.string(),
  count: z.number(),
});

export type INewHireReportingSummaryItem = z.infer<
  typeof newHireReportingSummaryItemSchema
>;

export const getNewHireReportingSummaryRequestSchema = z.object({
  start_date: z.string().optional(),
  end_date: z.string().optional(),
});

export type TGetNewHireReportingSummaryRequest = z.infer<
  typeof getNewHireReportingSummaryRequestSchema
>;

export const getNewHireReportingSummaryResponseSchema = z.object({
  data: z.array(newHireReportingSummaryItemSchema),
});

export type TGetNewHireReportingSummaryResponse = z.infer<
  typeof getNewHireReportingSummaryResponseSchema
>;
